<div [id]="item.id" class="card-content root-container">
    <img class="card-image d-none d-lg-inline" [src]="'../../../assets/images/'+ item.img " [alt]="item.title">
    <div class="card-texts">
            <h2 class="card-title">{{item.title}}</h2>
            <span class="card-text">{{item.description}}</span>

        <a [href]="item.link">
            <button type="button" class="card-button">
                <span class="card-button-label">Ingresar</span>
            </button>
        </a>
    </div>
</div>
<div class="card-decoration">
    <img class="card-button-img" src="../../../assets/images/card-decoration.svg" alt="">
</div>
